<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="contents">
<div class="header">
<h3>Table of Contents</h3>
</div>
<h3 class="sigil_not_in_toc"><a href="#/Text/Section0004">The Translator’s Foreword.</a></h3>
<h4 class="sigil_not_in_toc"><a href="#/Text/Section0005">The Book of The Thousand Nights and a Night</a></h4>
<ol>
<li><a href="#/Text/Section0005">Nur Al–Din Ali and the Damsel Anis Al–Jalis</a></li>
<li>
<a href="#/Text/Section0006">Tale of Ghanim bin Ayyub, the Distraught, the Thrall o’ Love.</a>
<ul>
<li><a href="#/Text/Section0007">Tale of the First Eunuch, Bukhayt.</a></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">Tale of the Second Eunuch, Kafur.</span></li>
</ul>
</li>
<li>
<span href="#/Text/Section0009" title="Link target outside of Sample">Tale of King Omar Bin Al–Nu’uman and his sons Sharrkan and Zau Al–Makan, and what befel them of things seld-seen and Peregrine.</span>
<ul>
<li>
<span href="#/Text/Section0010" title="Link target outside of Sample">Tale of Taj al-Muluk and the Princess Dunya (The Lover and the Loved).</span>
<ul>
<li><span href="#/Text/Section0011" title="Link target outside of Sample">Tale of Aziz and Azizah.<br/></span></li>
</ul>
</li>
</ul>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9ffd7cde